import axios from "axios";
import { APICLIENT } from "../shared/index";
import { apiendpoints } from "../constants/api-endpoints";

// ********GET_ALL_PROFILE ***********
export const getProfileDetails = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.GET_PROFILE_DETAILS);
    return APICLIENT.handleResponse(response);
  } catch (error) {
    return APICLIENT.handleError(error);
  }
};

//******* Update Contact *********
export const contactUpdate = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(apiendpoints.UPDATE_CONTACT, data);
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//******* Update Preferences **************
export const preferencesUpdate = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.UPDATE_PREFERENCE,
      data
    );
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//******* Update Password *********
export const passwordUpdate = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(apiendpoints.UPDATE_PASSWORD, data);
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
